import React from 'react';
import RepayMarathonComponent from '../components/repay-marathon';

const RepayMarathon = () => {
  return <RepayMarathonComponent />;
};

export default RepayMarathon;
